import Button from "src/components/Button";
import Card from "src/components/Card";
import FacebookButton from "src/components/FacebookButton";
import Container from "src/components/layout/Container";
import Line from "src/components/Line";
import useAuth from "src/hooks/selectors/useAuth";
import { useParseRedirectUrl } from "src/hooks/useRedirectUrl";
import LoginForm from "src/components/forms/auth/LoginForm";
import Logo from "src/components/Logo";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthLayout from "src/components/layout/AuthLayout/AuthLayout";
import useTenant from "src/hooks/api/services/tenants/useTenant";
import useQueryString from "src/hooks/useQueryString";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import Link from "src/components/Link";

const LoginView = ({ t }: Translation) => {
	const qs = useQueryString();
	const url = useParseRedirectUrl();
	const auth = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	const { tenant } = useTenant();
	useEffect(() => {
		if (auth?.id) {
			navigate(url || "/dashboard");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth, location]);

	const test = 1;
	if (test) {
		return (
			<AuthLayout head={{ title: t("title") }}>
				{qs?.password_reset === "success" && (
					<div className="bg-green-200 mb-4 p-4 flex flex-col text-green px-6 rounded-md">
						<p>{t("password-reset.success")}</p>
					</div>
				)}

				{auth?.id ? (
					<>
						<h2>{t("already-signed-in.title")}</h2>
						<div className="flex items-center mt-4">
							<Button to="/dashboard">
								{t("already-signed-in.button")}
								<i className="fas fa-arrow-right ml-4"></i>
							</Button>
						</div>
					</>
				) : (
					<>
						<div className="flex flex-col flex-1">
							<FacebookButton
								redirectUrl={url || undefined}
								type="login"
							/>
							<Line label={t("or")} />
							<LoginForm redirectUrl={url || undefined} />
						</div>
						<div className="mt-4 flex justify-center items-center flex-col">
							<Link className="text-center" to="/signup">
								<span>{t("no-account.label")}</span>
								<strong className="ml-2">
									{t("no-account.cta")}
								</strong>
							</Link>
						</div>
					</>
				)}
			</AuthLayout>
		);
	}

	return (
		<div className="flex flex-col flex-1 justify-center overflow-hidden">
			<Container variant="xsmall">
				<Card className="text-dark z-20 relative" bg="white">
					{auth?.id ? (
						<>
							<h2>{t("already-signed-in.title")}</h2>
							<div className="flex items-center mt-4">
								<Button to="/dashboard">
									{t("already-signed-in.button")}
									<i className="fas fa-arrow-right ml-4"></i>
								</Button>
							</div>
						</>
					) : (
						<>
							<h2 className="mb-2">{t("title")}</h2>
							<FacebookButton
								redirectUrl={url || undefined}
								type="login"
							/>
							<Line label={t("or")} />
							<LoginForm redirectUrl={url || undefined} />
							<div className="mt-4 flex justify-center items-center flex-col">
								<a
									className="underline text-center"
									href={tenant?.urls?.public + "/aanmelden"}
								>
									{t("no-account")}
								</a>
							</div>
						</>
					)}
				</Card>
			</Container>
			<div className="absolute right-4 bottom-4 z-10">
				<Logo color="primary" className="w-[300px] block" />
			</div>
		</div>
	);
};

LoginView.locale = {
	nl: {
		"already-signed-in": {
			title: "Je bent al ingelogd",
			button: "Naar dashboard",
		},
		or: "of via email",
		title: "Inloggen",
		"no-account": {
			label: "Nog geen account?",
			cta: "Maak deze gemakkelijk aan.",
		},
		"password-reset": {
			success:
				"Je wachtwoord is aangepast, je kan nu d.m.v. je nieuwe wachtwoord inloggen",
		},
	},
	en: {
		"already-signed-in": {
			title: "You are already signed in",
			button: "Go to dashboard",
		},
		or: "via email",
		title: "Login",
		"no-account": {
			label: "No account?",
			cta: "Create it easily",
		},
		"password-reset": {
			success:
				"The password has changed, you are now able to login with your new credentials",
		},
	},
};

export default withTranslation(LoginView);
